import auth from '@/router/auth'
import CourseIndex from '@/components/courses/Index'
import CourseCreate from '@/components/courses/Create'
import CourseCopy from '@/components/courses/Copy'
import CourseCreateExcel from '@/components/courses/CreateExcel'
import CourseUpdate from '@/components/courses/Update'
import TeacherCourseMain from '@/components/courses/TeacherCourseMain'
import CourseShow from '@/components/courses/Show'
import CategoryItemConfig from '@/components/courses/Config'

export default [
  {
    path: '/courses',
    name: 'courses-index',
    component: CourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/create',
    name: 'courses-create',
    component: CourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/copy',
    name: 'courses-copy',
    component: CourseCopy,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/create-excel',
    name: 'courses-create-excel',
    component: CourseCreateExcel,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/update/:course_id',
    name: 'courses-update',
    component: CourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/update-v2/:course_id',
    name: 'courses-update-v2',
    component: TeacherCourseMain,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/update-chapter-lesson/:id',
    name: 'courses-update-config',
    component: CategoryItemConfig,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/show/:course_id',
    name: 'courses-show',
    component: CourseShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/courses/router.js